import request from "../request";

export async function getRegister(params) {
    return request({
        url: '/user/register',
        method: "post",
        data: params,
    });
}


export async function getLogin(params) {
    return request({
        url: '/user/login',
        method: "post",
        data: params,
    });
}

/**
 * 获取用户信息
 * @param params
 * @returns {Promise<*>}
 */
export async function getUserInfo(params) {
    return request({
        url: '/user/get_current_user_info',
        method: "post",
        data: params,
    });
}
/**
 * 获取用户信息
 * @param params
 * @returns {Promise<*>}
 */
export async function getEditUser(params) {
    return request({
        url: '/user/edit_user',
        method: "post",
        data: params,
    });
}






